// import { createContext } from "react";
// const notesContext = createContext();

// export default notesContext;
import { createContext } from "react";
const noteContext = createContext();
export default noteContext;